import { NamespaceService } from "@/services/namespace-service"
import { Utils } from "./utils"
import Vue from 'vue'

export async function init_shares(shares, existing_initialized_shares=null){
    /**
     * Initializes the given raw shares with attributes needed to display them with share-card.vue
     * The shares array is modified in-place.
     * 
     * @param shares Array of shares, as returned by ShareService
     * @param existing_initialized_shares Array of already initialized shares, used to set the state of newly initialized ones
     * @return False if there was an error loading the shared files/folders, True otherwise
     */

    // Load shared ns entities
    const entity_ids = [...new Set(shares.map(share => share.contents).flat())]

    // Sharing is only possible from the default namespace (Team Files), load entities from here
    NamespaceService.ns_type = NamespaceService.NS_TYPE_DEFAULT
    const shared_entities = await NamespaceService.get_files_by_id(entity_ids, true)
                            .then(res => res.body)
                            .catch(() => null)
    if(!shared_entities) return false 
    
    // Init shares, show share details by default if there are less than 5 active shares
    const open_share_details = shares.filter(s => s.active).length < 5
    shares.forEach(share => {
        // Initializtes a Share
        share.entities = shared_entities.filter(e =>  share.contents.includes(e.id))
                                .map(entity => structuredClone(entity)) // clone each so files that are in multiple shares are not references to the same item in `entities`
        // Entity path: remove the entity name itself from the end of path
        share.entities.filter(e => e.path).forEach(entity => {
            const path_parts = entity.path.split('/')
            entity.path = path_parts.length == 1 
                            ? null 
                            : path_parts.slice(0, path_parts.length-1).join('/') // end with a '/'
        })
        // Add download count to each file if download-limited share
        if(share.download_limit > 0){
            share.entities.forEach(file => file.downloads_count = share.downloads_per_file?.[file.id] || 0)
        }
        // Sort the shared entities in-place: group by path, sort by name within the same path
        Utils.sortByKeys(share.entities, ['path', 'name'], false, true) 
        // Construct link
        share.link = Vue.filter('share_link')(share.alphakey)
        
        // Carry over current settings (show_all_files, show_info) if the shares are already shown 
        const existing_share = existing_initialized_shares?.find(s => s.id == share.id)
        if(existing_share){
            share.show_all_files = existing_share.show_all_files
            share.show_info = existing_share.show_info
        }
        else{
            // first render, default settings
            share.show_all_files = false
            share.show_info = open_share_details
        }
    })

    // Order shares from most recent to oldest (in-place)
    Utils.sortByKeys(shares, 'created', true, true)
    return true
}